<template>
  <settings-wrapper>
    <div class="custom-tab fill-height">
      <p class="mt-5 font-weight-medium"
        :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('pages.additionalAccounts.client')}} {{userSettings.name}}!</p>

      <template v-if="additionalAccounts && additionalAccounts.length">
        <p :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">{{$t('pages.additionalAccounts.info')}}</p>

        <v-data-table
          v-if="windowSize.x > 768"
          :headers="headers"
          :items="additionalAccounts"
          :footer-props="{'items-per-page-text': $t('pages.additionalAccounts.linesPerPage')}"
          class="elevation-1 table-zebra-colored"
        >
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>

            <v-icon small @click="openDeleteDialog(item)" size="40">mdi-delete-forever</v-icon>
          </template>
        </v-data-table>

        <v-data-table
          v-else
          :headers="headers"
          :footer-props="{'items-per-page-text': $t('pages.additionalAccounts.linesPerPage')}"
          :items="additionalAccounts"
          class="elevation-1 table-zebra-colored"
        >
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>

            <v-icon small @click="openDeleteDialog(item)" size="40">mdi-delete-forever</v-icon>
          </template>
        </v-data-table>
      </template>

      <div v-else class="information-text">
          {{$t('pages.additionalAccounts.notLS')}}
      </div>

      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <div class="text-center text-sm-right mt-6">
            <v-btn @click="edit = true" v-on="on" dark class="blue-button"
            :class="{'button-font': currentLocale === 'tat'}">{{$t('buttons.addLS')}}</v-btn>
          </div>
        </template>

        <v-card>
          <v-card-title class="divider_orange py-4">
            <span class="display-1">{{ formTitle }}</span>

            <div class="flex-grow-1"></div>

            <v-btn @click="close" icon text x-small>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pt-5 pb-0">
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.name"
                  :label="$t('pages.additionalAccounts.nameLS')"
                  :disabled="loading"
                  outlined
                  :rules="requireRules"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.surname"
                  :label="$t('pages.additionalAccounts.familyEPD')"
                  :disabled="loading || accountDialogInEditMode"
                  outlined
                  :rules="!accountDialogInEditMode ? requireRules : []"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.domHoz"
                  :label="$t('pages.additionalAccounts.numberLsEPD')"
                  :disabled="loading || accountDialogInEditMode"
                  outlined
                  :rules="requireRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pb-4 pt-0 px-4">
            <v-spacer></v-spacer>
            <v-btn @click="close" outlined class="mr-4 outlined-transparent-button" large>{{$t('buttons.cancel')}}</v-btn>
            <v-btn class="green-button" large dark @click="save" :loading="loading">{{$t('buttons.save')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <ModalDelete
        @deleteItem="deleteItem"
        :loading="loading"
        :attentionText="$t('pages.additionalAccounts.deleteLS')"
        v-model="deleteDialog"
        @closeDeleteDialog="closeDeleteDialog"
      ></ModalDelete>
    </div>
  </settings-wrapper>
</template>
<script>
import SettingsWrapper from "../../../components/settings/wrappers";
import ModalDelete from "../../../components/modals/ModalDelete";
import { mapGetters } from "vuex";

export default {
  layout: "main",
  components: {
    SettingsWrapper,
    ModalDelete
  },
  name: "TabItemAdditionalAccounts",
  props: {
    value: String
  },
  data: () => ({
    dialog: false,
    accounts: [],
    accountDialogInEditMode: false,
    editedItem: {
      name: "",
      surname: "",
      domHoz: ""
    },
    defaultItem: {
      name: "",
      surname: "",
      domHoz: ""
    },
    deleteDialog: false,
    itemToDelete: null,
    loading: false,
    windowSize: {
      x: 0,
      y: 0
    },
  }),
  computed: {
    ...mapGetters("locale",["currentLocale"]),
    
    formTitle() {
      return this.accountDialogInEditMode
        ? this.$t('pages.additionalAccounts.changeLS')
        : this.$t('pages.additionalAccounts.addLS');
    },
    userSettings() {
      return { ...this.$store.getters["account/userSettings"] };
    },
    additionalAccounts() {
      return [...this.$store.getters["account/additionalAccounts"]];
    },
    headers(){
      return [
      {
        text: this.$t('personalAccount'),
        align: "left",
        sortable: false,
        value: "domHoz"
      },
      {
        text: "Фамилия",
        value: "surname",
        sortable: false
      },
      {
        text: this.$t('pages.additionalAccounts.nameLS'),
        value: "name",
        sortable: false
      },
      {
        text: "",
        value: "action",
        sortable: false
      }
    ]
    },
    requireRules(){ return  [v => !!v || this.$t('rules.fieldRequire')]},
  },
  mounted() {
    this.onResize();
  },
  methods: {
    editItem(item) {
      this.accountDialogInEditMode = true;

      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    openDeleteDialog(item) {
      this.deleteDialog = true;
      this.itemToDelete = item;
    },
    deleteItem() {
      this.loading = true;
      this.$store
        .dispatch("account/deleteAdditionalAccount", this.itemToDelete)
        .then(() => {
          this.$store.dispatch("account/updateUser");
          this.loading = false;
          this.deleteDialog = false;
        });
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.accountDialogInEditMode = false;
      }, 300);
    },
    save() {
      this.loading = true;
      if (this.accountDialogInEditMode) {
        
        this.$store
          .dispatch("account/updateAdditionalAccount", this.editedItem)
          .then(() => {
            this.$store.dispatch("account/updateUser");
            this.loading = false;
            this.close();
            this.editedItem.name = "ЛС №"+this.editedItem.domHoz+"; " + this.editedItem.name;
          });
          
      } else {
        this.$store
          .dispatch("account/addAdditionalAccount", this.editedItem)
          .then(() => {
            this.$store.dispatch("account/updateUser");
            this.loading = false;
            this.close();
            this.editedItem.name = "ЛС №"+this.editedItem.domHoz+"; " + this.editedItem.name;
          });
      }
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
};
</script>


<style lang="scss" scoped>
tr.v-data-table__empty-wrapper {
  td {
    padding-top: 25px;
    padding-bottom: 25px;
    color: #4d4d4d;
  }
}

.information-text {
  min-height: 150px;
}

.button-font{
  font-family: Rubik-Medium !important;
  white-space: normal;
}
</style>
